import { render } from "./Header.vue?vue&type=template&id=4bfa482a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4bfa482a&scoped=true&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=4bfa482a&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfa482a"]])

export default __exports__